import { render } from "./AdmissionTicketPage.vue?vue&type=template&id=19ce64e5&scoped=true"
import script from "./AdmissionTicketPage.vue?vue&type=script&lang=js"
export * from "./AdmissionTicketPage.vue?vue&type=script&lang=js"

import "./AdmissionTicketPage.vue?vue&type=style&index=0&id=19ce64e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ce64e5"]])

export default __exports__